import {SOPutRole} from '../../core/role/so-put-role';
import {RoleCore} from './role.core';
import {SOGetRole} from '../../core/role/so-get-role';
import {FormField, SelectionOption} from 'lionheartland';
import {putRoleFormFieldOptions} from './put-role-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePut} from 'lionheartland';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPutRole extends BasePut implements AdapterProtocol {
  formFieldOptions = Object.values(putRoleFormFieldOptions);

  RequestClass = SOPutRole

  constructor(
    public entityCore: RoleCore
  ) {
    super();
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.selectedEntity.uid,
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}